export default __webpack_public_path__ + "static/media/ayam-bakar.f42cd1ba.jpg";